// extracted by mini-css-extract-plugin
module.exports = {"patientDiseasesAccordion":"patient-diseases_patientDiseasesAccordion__3ahgj","patientDiseasesRow":"patient-diseases_patientDiseasesRow__1UMXt"};